"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function GalleryUnlockForm() {
  const router = useRouter();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/gallery-unlock", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        router.refresh();
      } else {
        const data = await res.json().catch(() => ({}));
        if (data?.reason === "not_configured") {
          setError("The gallery is not available right now. Please contact the Trichos team.");
        } else if (data?.reason === "disabled") {
          setError("The gallery is currently closed. Please contact the Trichos team.");
        } else {
          setError("That password is not correct. Please check with the Trichos team.");
        }
      }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="flex min-h-[60vh] items-center justify-center px-6 py-16">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
      >
        <h1 className="mb-3 text-2xl font-bold text-gray-900">Patient gallery</h1>
        <p className="mb-6 text-sm text-gray-600">
          This gallery is available only to patients during their consultation at Trichos.
          Please enter the password shared with you by the clinic.
        </p>
        <label htmlFor="gallery-password" className="mb-2 block text-sm font-medium text-gray-800">
          Password
        </label>
        <input
          id="gallery-password"
          type="password"
          autoComplete="off"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 focus:border-purple-500 focus:outline-none"
          required
        />
        {error && <p className="mb-4 text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={loading || !password}
          className="w-full rounded-lg bg-purple-600 px-4 py-3 font-medium text-white disabled:opacity-60"
        >
          {loading ? "Checking…" : "View gallery"}
        </button>
      </form>
    </section>
  );
}
